import { sanitizeText, formatDate, normalizeImageUrl } from "./sanitize";
import type {
  StructuredDataVideoObject,
  StructuredDataInputMedia,
} from "./types";

function normalizeVideoUrl(url?: string | null): string {
  if (!url) return "";
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== "https:") return "";
    return parsed.toString();
  } catch {
    return "";
  }
}

export function buildVideoSchema(
  media: StructuredDataInputMedia
): StructuredDataVideoObject {
  const primaryImage =
    media.images?.find((img) => img.isPrimary) ?? media.images?.[0];
  const thumbnailUrl = normalizeImageUrl(primaryImage?.url);

  const uploadDate = formatDate(media.uploadDate) || new Date().toISOString();

  const result: StructuredDataVideoObject = {
    "@type": "VideoObject",
    name: sanitizeText(media.name ?? ""),
    description: sanitizeText(media.description ?? ""),
    contentUrl: normalizeVideoUrl(media.catwalkUrl),
    thumbnailUrl,
    uploadDate,
  };

  return result;
}
